import * as React from 'react';
import { Distance, VolumeCell } from '../ui/shared/format-components';
import { observer } from 'mobx-react';
import { GroupRange, ITripStatsSum } from '../store/StatsStore';
import { DateSpan } from '@shared/ui-react/UtilComponents';
import { DateUtils } from '@shared/utils/DateUtils';

@observer
export class MaterialStatsTableTBody extends React.Component<{
    stats: ITripStatsSum;
    groupedBy: GroupRange;
}> {
    render() {
        const stats = this.props.stats;
        const showTotalRow = stats.items.length > 1;

        return (
            <tbody>
                {stats.items.map((s, i) => (
                    <tr key={i}>
                        {this.renderFirstCell(i)}
                        <td>{s.material.material}</td>
                        <td>{this.renderVolumeCell(s.m3Loose, s.m3LooseDerived)}</td>
                        <td>{this.renderVolumeCell(s.m3Solid, s.m3SolidDerived)}</td>
                        <td>{this.renderVolumeCell(s.tons, s.tonsDerived)}</td>
                        <td>{this.renderVolumeCell(s.pieces, s.piecesDerived)}</td>
                        <td>{DateUtils.secondsToDateTime(s.tripTime)}</td>
                        <td>{s.tripsCount}</td>
                        <td>
                            <Distance distance={s.distance} />
                        </td>
                        <td>
                            <Distance distance={s.distance / s.tripsCount} />
                        </td>
                    </tr>
                ))}

                {showTotalRow && (
                    <tr>
                        <td>{__('trucks.trips.table_total')}</td>
                        <td>{this.renderVolumeCell(stats.totalM3Loose, stats.totalM3LooseDerived)}</td>
                        <td>{this.renderVolumeCell(stats.totalM3Solid, stats.totalM3SolidDerived)}</td>
                        <td>{this.renderVolumeCell(stats.totalTons, stats.totalTonsDerived)}</td>
                        <td>{this.renderVolumeCell(stats.totalPieces, stats.totalPiecesDerived)}</td>
                        <td>{DateUtils.secondsToDateTime(stats.totalTime)}</td>
                        <td>{stats.totalCount}</td>
                        <td>
                            <Distance distance={stats.totalDistance} />
                        </td>
                        <td>
                            <Distance distance={stats.totalDistance / stats.totalCount} />
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    renderFirstCell(rowIndex) {
        // date cell
        const firstItem = this.props.stats.items[0];
        const count = this.props.stats.items.length;
        const rowSpan = rowIndex === 0 ? count + (count > 1 ? 1 : 0) : null;

        if (rowIndex > 0) return null;

        if (this.props.groupedBy === 'all') {
            return null;
        } else if (this.props.groupedBy === 'day') {
            return (
                <td rowSpan={rowSpan}>
                    <DateSpan timestamp={firstItem.date} />
                </td>
            );
        } else if (this.props.groupedBy === 'week') {
            return <td rowSpan={rowSpan}>{firstItem.weekAndYear}</td>;
        } else if (this.props.groupedBy === 'month') {
            return <td rowSpan={rowSpan}>{firstItem.monthAndYear}</td>;
        }
    }

    renderVolumeCell(value: number | null | undefined, isDerived: boolean | null | undefined) {
        return <VolumeCell displayValue={{ value: value ?? null, isDerived: isDerived === true }} />;
    }
}
